import { ref } from 'vue'
import { ContactType } from '@/api/types'
import { IPaymentProfileAttributes } from '@/interfaces/paymentProfiles'
import { usePaymentProfilesStore } from '@/store/modules/paymentProfiles'

const useFetchPaymentProfile = () => {
  const paymentProfilesStore = usePaymentProfilesStore()
  const record = ref<IPaymentProfileAttributes>({
    id: undefined,
    sid: '',
    account_type: ContactType.Personal,
    account: '',
    first_name: '',
    last_name: '',
    country_code: '',
    address: '',
    company_name: '',
    verify: false,
    verified: false,
    blocked: false,
    message: '',
    title: ''
  })
  const fetchingPaymentProfile = ref(true)

  function fetchPaymentProfile(
    sid: string
  ): Promise<IPaymentProfileAttributes> {
    return new Promise((resolve, reject) => {
      paymentProfilesStore.FetchItem(sid).then(() => {
        fetchingPaymentProfile.value = false

        const existingRecord = paymentProfilesStore.items[sid]

        if (existingRecord !== undefined) {
          record.value = existingRecord
          resolve(existingRecord)
        }
        reject(new Error('Record not found'))
      })
    })
  }

  return { record, fetchingPaymentProfile, fetchPaymentProfile }
}

export default useFetchPaymentProfile
